import { connect } from 'react-redux';
import ConfirmCheck from 'components/pages/ConfirmCheck';

const mapStateToProps = ({ user }) => ({
  isConfirmed: user.is_confirmed,
});

export default connect(mapStateToProps)(ConfirmCheck);
